<script>
import BaseEChartPie     from '@/theme/default/components/charts/echarts/BaseEChartPie'
import { toDecimalMark } from '@/lib/utils/helper'

export default {
  name    : 'EChartSurveyPie',
  extends : BaseEChartPie,
  computed: {
    series () {
      let values = []

      if (this.chartDataOptions.length) {
        values = this.chartDataOptions
      }

      return {
        type     : 'pie',
        // roseType : 'radius',
        top      : this.pieTop,
        left     : this.pieLeft,
        right    : this.pieRight,
        bottom   : this.pieBottom,
        width    : this.pieWidth,
        height   : this.pieHeight,
        center   : this.pieCenter,
        radius   : this.pieRadius,
        label    : { show: false },
        labelLine: { show: false },
        tooltip  : {
          formatter: params => {
            const value = toDecimalMark(parseFloat(params.value), 0)

            return `<div class="pr-4"><span class="mr-2">${ params.marker } ${ params.name }</span><br /><span class="ml-0 synthesis-text text-size-18 font-weight-regular">${ value }%</span></div>`
          }
        },
        itemStyle: {
          borderColor : this.pieBorderColor,
          borderWidth : this.pieBorderWidth,
          borderRadius: this.pieBorderRadius
        },
        cursor: this.cursor,
        data  : values
      }
    },
    getChartDataOptions () {
      return {
        animation         : this.chartAnimation,
        animationThreshold: this.chartAnimationThreshold,
        animationDuration : this.chartAnimationDuration,
        animationEasing   : this.chartAnimationEasing,
        tooltip           : {
          trigger        : 'item',
          show           : this.tooltipShow,
          confine        : this.tooltipConfine,
          backgroundColor: this.themeColorRGBA(this.tooltipBackgroundColor, 0.8),
          borderColor    : this.tooltipBorderColor,
          borderWidth    : this.tooltipBorderWidth,
          padding        : this.tooltipPadding,
          textStyle      : {
            color: this.tooltipLabelColor
          }
        },
        legend: {
          show     : this.legendShow,
          orient   : this.legendOrient,
          top      : this.legendTop,
          bottom   : this.legendBottom,
          left     : this.legendLeft,
          right    : this.legendRight,
          align    : this.legendAlign,
          padding  : this.legendPadding,
          data     : this.legendData,
          textStyle: {
            fontFamily: this.pieLegendFontFamily,
            fontSize  : this.pieLegendFontSize,
            color     : this.pieLegendFontColor,
            fontStyle : this.pieLegendFontStyle,
            fontWeight: this.pieLegendFontWeight
          }
        },
        color    : this.defaultColors ?? this.colors,
        textStyle: {
          fontFamily: this.fontFamily,
          fontSize  : this.fontSize,
          color     : this.fontColor,
          fontStyle : this.fontStyle,
          fontWeight: this.fontWeight
        },
        grid  : this.getChartGridMargin,
        series: this.series
      }
    }
  }
}
</script>

<style scoped>
.chart {
  width: 100%;
}
</style>
